<template>
  <div class="payment-container">
    <div class="payment-card">
      <div class="payment-header">
        <h1>Complete Your Payment</h1>
        <p class="order-info">Order #{{ orderId }}</p>
      </div>
      
      <div class="payment-details">
        <div class="detail-row">
          <span class="detail-label">Amount Due:</span>
          <span class="detail-value">AED {{ amount.toFixed(2) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      amount: 0
    }
  },
  mounted() {
    // Get amount from query parameters
    this.amount = parseFloat(this.$route.query.amount) || 0;
  },
  methods: {
    processPayment() {
      // Add your payment processing logic here
      alert(`Processing payment of AED ${this.amount.toFixed(2)} for order #${this.orderId}`);
    }
  }
}
</script>

<style scoped>
.payment-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
}

.payment-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  padding: 30px;
}

.payment-header {
  text-align: center;
  margin-bottom: 30px;
}

.payment-header h1 {
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.order-info {
  color: #7f8c8d;
  font-size: 16px;
}

.payment-details {
  margin: 25px 0;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid #ecf0f1;
}

.detail-label {
  color: #7f8c8d;
  font-weight: 500;
}

.detail-value {
  color: #2c3e50;
  font-weight: 600;
  font-size: 18px;
}

.pay-button {
  width: 100%;
  padding: 15px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.pay-button:hover {
  background-color: #2980b9;
}
</style>